<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';
import TranscriptionToggle from './TranscriptionToggle.vue';
import Caption from './Caption.vue';
import PdfPreviewDialog from './PdfPreviewDialog.vue';
import { MESSAGE_TYPES } from '../constants';

const { attachments, content, messageType } = useMessageContext();

// Transcrição automática (mídia do lead) fica retrátil; legenda que o
// atendente digita ao enviar é fala dele, mostra sempre.
const isIncoming = computed(() => messageType.value === MESSAGE_TYPES.INCOMING);

const { t } = useI18n();

const url = computed(() => {
  return attachments.value[0].dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});

const isPdf = computed(() => fileType.value?.toLowerCase() === 'pdf');

const pdfPreviewRef = ref(null);
const openPdfPreview = () => pdfPreviewRef.value?.open();
</script>

<template>
  <BaseAttachmentBubble
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="decodeURI(fileName)"
    :action="{
      href: url,
      label: $t('CONVERSATION.DOWNLOAD'),
    }"
    :secondary-action="
      isPdf
        ? { onClick: openPdfPreview, label: $t('CONVERSATION.PREVIEW') }
        : null
    "
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
    <template v-if="content" #footer>
      <TranscriptionToggle v-if="isIncoming" :content="content" />
      <Caption v-else :content="content" />
    </template>
  </BaseAttachmentBubble>
  <PdfPreviewDialog
    v-if="isPdf"
    ref="pdfPreviewRef"
    :url="url"
    :file-name="decodeURI(fileName)"
  />
</template>
